import React, { useState } from "react";
import { Trophy, Ban } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";

/**
 * Toggle-knapp som eier kan klikke på bildet i AlbumView for å si
 * "ikke ta dette med i 'ukens bilde'-konkurransen".
 */
export default function WeeklyOptOutToggle({ imageId, optedOut, onChanged }) {
  const [busy, setBusy] = useState(false);
  const [state, setState] = useState(!!optedOut);

  const toggle = async () => {
    setBusy(true);
    try {
      const newState = !state;
      await api.post("/contests/weekly-image/opt-out", {
        image_id: imageId,
        opt_out: newState,
      });
      setState(newState);
      toast.success(newState ? "Bildet er nå utenfor ukens konkurranse" : "Bildet er nå med igjen");
      if (onChanged) onChanged();
    } catch (e) {
      toast.error(formatApiError(e));
    } finally { setBusy(false); }
  };

  return (
    <button
      type="button"
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggle(); }}
      disabled={busy}
      title={state ? "Klikk for å bli med i ukens konkurranse" : "Klikk for å holde dette utenfor ukens bilde"}
      className={`inline-flex items-center gap-1 px-2 py-1 rounded-sm text-[10px] font-meta uppercase tracking-[0.12em] transition ${
        state
          ? "bg-black/70 border border-white/15 text-[var(--cream-soft)] hover:text-[var(--magenta)]"
          : "bg-[var(--magenta)]/15 border border-[var(--magenta)]/40 text-[var(--magenta)] hover:bg-[var(--magenta)] hover:text-black"
      }`}
      data-testid={`weekly-opt-${imageId}`}
    >
      {state ? <Ban className="h-3 w-3" /> : <Trophy className="h-3 w-3" />}
      {state ? "Skjul" : "Konkurrer"}
    </button>
  );
}
